import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledBlogCard = styled.div<any>`
  .blog-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    -webkit-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
    -moz-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
    box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
    padding: 2rem;
    padding-top: 100px;
    position: relative;
    background-color: var(--colors-white);
    transition: transform 0.2s ease-in-out;
    max-width: 400px;
    height: 100%;

    @media ${breakpoints.tablet} {
      max-width: 100%;
    }

    &__feature-image {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      position: absolute;
      top: -75px;
      z-index: 1;
      box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.2);

      img {
        border-radius: 50%;
        object-fit: cover;
        width: 150px !important;
        height: 150px !important;
        aspect-ratio: 1 / 1;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .blog-header {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    &__title {
      color: var(--colors-primary-bright);
    }

    &__date {
      color: var(--colors-black);
      font-weight: 600;
    }

    .category {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    &__link {
      color: var(--colors-primary-bright);
      margin-top: 2rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      p {
        color: var(--colors-primary-bright);
        border-bottom: 1px solid var(--colors-primary-bright);
        line-height: 0.9rem;
      }

      span {
        transition: transform 0.2s ease-in-out;
      }
    }

    &:hover {
      transform: translateY(-5px);
      cursor: pointer;

      .blog-card__link span {
        transform: translateX(2px);
      }
    }
  }
`;
